import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useParams,
  useNavigate,
} from "react-router-dom";
import ReactDOM from "react-dom";
import Web3 from "web3";

import { NavLink, Link } from "react-router-dom";
import $ from "jquery";

// import profile from "../../../images/profile.jpg";
import logo from "../../../images/homepage/logoNew.svg";
import miniLogo from "../../../images/homepage/miniLogo.svg";

import overviewICo from "../../../images/overviewICo.png";
import ethIco from "../../../images/ethIco.png";
import transactionIco from "../../../images/transactionIco.png";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Modal } from "react-bootstrap";
import { useAlert } from "react-alert";
import axios from "axios";
import { ArrowDown } from "lucide-react";

function SidebarPortfolio({ allwallets, deleteWallet }) {
  const location = useLocation();
  const navigate = useNavigate();
  // example: /portfolio/65abc123xyz
  const pathParts = location.pathname.split("/");
  const portfolioId = pathParts[pathParts.length - 1]; // adjust index if needed

  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [portfolio, setPortfolio] = useState([]);
  const userStore = useSelector((state) => state.userReducer);
  const [inputData, setInputData] = useState({});
  const [pLoader, setPLoader] = useState(false);
  const [portfolioType, setPortfolioType] = useState("");
  const [editOn, setEditOn] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setPortfolioType("");
    setInputData({});
  };
  const handleShow = () => {
    setShow(true);
  };

  const getPortfolio = async () => {
    // e.preventDefault();
    setLoader(true);
    try {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token");
      const addResponse = await api.userPortfolioGet();
      // console.log(addResponse);

      if (addResponse?.success) {
        setPortfolio(addResponse?.res || []);
        setLoader(false);
        if (addResponse?.res) {
          if (addResponse?.res.length == 0) {
            navigate(`/portfolio`);
          }
        }
      } else {
        setLoader(false);
      }
    } catch (e) {
      console.log(e.message);
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (userStore?.users?.user?._id) {
      getPortfolio();
    }
  }, [userStore?.users]);

  const handleInput = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const validatePF = () => {
    const inputElement = document.querySelector("input[name='name']");
    const name = (inputData?.name || inputElement?.value || "").trim();

    if (!name) {
      return "Name is required";
    }
    if (name.length > 25) {
      return "Name not more than 25 character.";
    }
    return false;
  };

  const createPfManual = async () => {
    try {
      let check = validatePF();
      if (check) {
        alert.show(check);
        return;
      }
      const payload = {
        ...inputData,
        type: portfolioType,
      };
      if (inputData?.wallet) {
        payload.wallet = inputData.wallet;
      }

      setPLoader(true);
      const addResponse = await api.portfolioInitiate(payload);
      // console.log(addResponse);
      if (addResponse?.success) {
        getPortfolio();
        if (addResponse?.res?.type == "wallet") {
          // navigate(`/portfolio/dashboard/${addResponse?.res?._id || 1}`);
          AddWallet(inputData?.wallet, addResponse?.res?._id);
        } else {
          navigate(`/portfolio/tx/${addResponse?.res?._id}`);
        }
      }
      setPortfolioType("");
      handleClose();
      setPLoader(false);
    } catch (error) {
      console.log(error);

      alert.show(error?.message || "SOMETHING WENT WRONG");
      setPLoader(false);
    }
  };

  const AddWallet = async (wallet, pid) => {
    // e.preventDefault();
    setPLoader(true);
    try {
      const payload = {
        userID: userStore?.users?.user?._id,
        wallet: wallet.toLowerCase(),
        portfolioID: pid,
      };
      // console.log(payload);

      const addResponse = await api.addWallet(payload);
      // console.log(addResponse);

      if (addResponse?.success) {
        alert.show("Wallet Added");
        navigate(`/portfolio/dashboard/${wallet}`);
        setPLoader(false);
      } else {
        setPLoader(false);
        alert.error(addResponse?.message || "Something went wrong");
      }
    } catch (e) {
      console.log(e);

      // alert.show(e?.message || "SOMETHING WENT WRONG");
      // alert.show("Invalid Credentials or Account not verified");
      setPLoader(false);
    }
  };

  const logingHandler = async () => {
    if (!window.ethereum) {
      // alert('Install ');
      alert.error("Install ");
    } else {
      let web3 = new Web3(window.ethereum);
      let accs = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      if (accs.length > 0) {
        let ad = accs[0].toLowerCase();
        // console.log(ad);
        setInputData({ ...inputData, wallet: ad });
      }
    }
    // setisConnecting(false)
  };

  const handleSetWallet = () => {
    setPortfolioType("wallet");
    logingHandler();
  };

  const deletePortfolio = async (pid) => {
    // e.preventDefault();
    setLoader(true);
    try {
      let payload = {
        portfolioID: pid,
      };
      const getResponse = await api.deletePortfolio(payload);
      // console.log(getResponse);

      if (getResponse?.success) {
        getPortfolio();
        if (portfolio[0]?.type == "wallet") {
          navigate(`/portfolio/dashboard/${portfolio[0]?.wallet || 1}`);
        } else {
          if (portfolio.length > 0) {
            navigate(`/portfolio/tx/${portfolio[0]?._id}`);
          } else {
            navigate(`/portfolio/tx/1`);
          }
        }
        setLoader(false);
      } else {
        alert.error("Something went wrong");
        setLoader(false);
      }
    } catch (e) {
      console.log(e);

      alert.show(e.message);
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  const handleCloseSidebar = () => {
    const element = document.getElementById("sidebarPortMobile");
    element.style.left = "-100%";
  };
  const handleOpenSidebar = () => {
    const element = document.getElementById("sidebarPortMobile");
    element.style.left = "0%";
  };

  return (
    <>
      {/* Sidebar */}
      <ul
        className="navbar-nav sidebar sidebar-dark accordion zi-1 sidebarPort1"
        id="accordionSidebar"
      >
        {/* Sidebar - Brand */}
        <Link
          className="sidebar-brand d-flex align-items-center justify-content-center mt-0"
          to="/"
        >
          <div className="sidebar-brand-text mx-3">
            <img src={logo} className="w-100" alt="waqarzaka.net" />
          </div>
          <div className="mini">
            <img src={miniLogo} className="w-40" alt="waqarzaka.net" />
          </div>
        </Link>
        <div className="sideInner sidebarPort ">
          {/* sidebar links */}

          <li className="nav-item my-1 ">
            <a className="nav-link d-flex jc-sb flex-wrap">
              <span className="ms -0">
                My Porfolio ({portfolio.length || 0})
              </span>
              {editOn ? (
                <i
                  className="fa-solid fa-check editPIco"
                  onClick={() => setEditOn(!editOn)}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-pen editPIco"
                  onClick={() => setEditOn(!editOn)}
                ></i>
              )}
            </a>
          </li>
          {portfolio.map((item, key) => (
            <li className="nav-item my-1 " key={key}>
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to={
                  item?.type == "manual"
                    ? `/portfolio/tx/${item?._id}`
                    : `/portfolio/dashboard/${item?.wallet}`
                }
              >
                {item?.type == "wallet" ? (
                  <div className="wIcon ">
                    <i className="fa-solid fa-wallet m-0"></i>
                  </div>
                ) : (
                  <div className="wIcon m-0">
                    <i className="fa-solid fa-chart-simple m-0"></i>
                  </div>
                )}
                <span className="">{item?.name}</span>
                {editOn && (
                  <div
                    className="dIco ms-auto"
                    onClick={() => deletePortfolio(item?._id)}
                  >
                    <i className="fa-regular fa-trash-can"></i>
                  </div>
                )}
              </NavLink>
            </li>
          ))}
          <li className="nav-item my-1 ">
            <a className="nav-link" onClick={handleShow}>
              <span
                className="ms -0"
                style={{ color: "#895aef", fontSize: 16, cursor: "pointer" }}
              >
                + Create Portfolio
              </span>
            </a>
          </li>
        </div>
      </ul>
      <ul
        className="navbar-nav sidebar sidebar-dark accordion zi-1 sidebarPortMobile"
        id="sidebarPortMobile"
      >
        {/* Sidebar - Brand */}
        <div className="sidebar-brand d-flex align-items-center justify-content-center mt-0">
          Portfolio
          <div className="closeIcon" onClick={handleCloseSidebar}>
            <i className="fa-solid fa-xmark" />
          </div>
        </div>
        <div className="sideInner sidebarPort ">
          {/* sidebar links */}

          <li className="nav-item my-1 ">
            <a className="nav-link d-flex jc-sb flex-wrap">
              <span className="ms -0">
                My Porfolio ({portfolio.length || 0})
              </span>
              {editOn ? (
                <i
                  className="fa-solid fa-check editPIco"
                  onClick={() => setEditOn(!editOn)}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-pen editPIco"
                  onClick={() => setEditOn(!editOn)}
                ></i>
              )}
            </a>
          </li>
          {portfolio.map((item, key) => (
            <li className="nav-item my-1 " key={key}>
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to={
                  item?.type == "manual"
                    ? `/portfolio/tx/${item?._id}`
                    : `/portfolio/dashboard/${item?.wallet}`
                }
                onClick={handleCloseSidebar}
              >
                {item?.type == "wallet" ? (
                  <div className="wIcon ">
                    <i className="fa-solid fa-wallet m-0"></i>
                  </div>
                ) : (
                  <div className="wIcon m-0">
                    <i className="fa-solid fa-chart-simple m-0"></i>
                  </div>
                )}
                <span className="">{item?.name}</span>
                {editOn && (
                  <div
                    className="dIco ms-auto"
                    onClick={() => deletePortfolio(item?._id)}
                  >
                    <i className="fa-regular fa-trash-can"></i>
                  </div>
                )}
              </NavLink>
            </li>
          ))}
          <li className="nav-item my-1 ">
            <a
              className="nav-link createPfBtn"
              onClick={() => {
                handleShow();
                handleCloseSidebar();
              }}
            >
              <span
                className="ms -0"
                style={{ color: "#895aef", fontSize: 16, cursor: "pointer" }}
              >
                + Create Portfolio
              </span>
            </a>
          </li>
        </div>
      </ul>
      {/* End of Sidebar */}

      <div className="activeMobileP" onClick={handleOpenSidebar}>
        {portfolio.map((item, key) => (
          <>
            {portfolioId == (item?.wallet || item?._id) && (
              <div className="activeCard" key={key}>
                {item?.type == "wallet" ? (
                  <div className="wIcon ">
                    <i className="fa-solid fa-wallet m-0"></i>
                  </div>
                ) : (
                  <div className="wIcon m-0">
                    <i className="fa-solid fa-chart-simple m-0"></i>
                  </div>
                )}
                <span className="">{item?.name}</span>
              </div>
            )}
          </>
        ))}
        <div className="opensideb">
          <ArrowDown />
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className="px-3 portfolio-modal" close>
          <div className="closeIcon" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </div>
          <h5
            className="bg-black mb-4 py-1"
            style={{ fontSize: "22px", fontWeight: 700 }}
          >
            Create Portfolio
          </h5>
          {portfolioType ? (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                createPfManual();
              }}
            >
              <div className="row g-3">
                <div className="col-12 mb-3">
                  <label>Enter Name</label>
                  <input
                    type="text"
                    className="form-control "
                    value={inputData?.name}
                    name="name"
                    onChange={(e) => handleInput(e)}
                    placeholder="Name..."
                    autoComplete="off"
                    onBlur={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                  />
                </div>
                {portfolioType == "wallet" && (
                  <div className="col-12 mb-3">
                    <label>Wallet Address</label>
                    <input
                      type="text"
                      className="form-control "
                      value={inputData?.wallet}
                      name="wallet"
                      onChange={(e) => handleInput(e)}
                      placeholder="Wallet..."
                    />
                  </div>
                )}

                <div className="col-12">
                  <button
                    type="submit"
                    // onClick={() => createPfManual()}
                    className="themeBtn w-100 py-2"
                    disabled={pLoader}
                  >
                    {pLoader && (
                      <i
                        className="fa fa-spinner fa-pulse mx-2 mb-1"
                        style={{ position: "relative", top: "-0px" }}
                      ></i>
                    )}
                    Submit
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <div className="portfolioOptionM mb-3">
              <div className="connentBtnM" onClick={() => handleSetWallet()}>
                <div className="icon">
                  <i className="fa-solid fa-wallet"></i>
                </div>
                <div>
                  <div className="title">Connect Your Wallet</div>
                  <div className="desc">
                    Simply connect your wallet and we'll sync it right away.
                  </div>
                </div>
              </div>
              <div
                className="connentBtnM"
                onClick={() => setPortfolioType("manual")}
              >
                <div className="icon">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
                <div>
                  <div className="title">Add Transactions Manually</div>
                  <div className="desc">
                    Enter all transaction details at your own pace to track your
                    portfolio.
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
export default SidebarPortfolio;
